import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDoeK5LjNOYpFLzQlGGMv8uO-dw7Zbwmxg",
  authDomain: "socialplay-b3831.firebaseapp.com",
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL || "https://moderatepolitics-rtdb.firebaseio.com",
  projectId: "socialplay-b3831",
  storageBucket: "socialplay-b3831.appspot.com",
  messagingSenderId: "520567936499",
  appId: "1:520567936029:web:8ab4a03edc4e84fb2322f4",
  measurementId: "G-HB5JEDPM96"
};

const app = initializeApp(firebaseConfig);
export const db = getDatabase(app);
export const storage = getStorage(app);
export const FIREBASE_DATABASE_URL = firebaseConfig.databaseURL.replace(/\/$/, '');
export default app;
